(function () {
  if (window.__animationsInit) return;
  window.__animationsInit = true;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  // Individual items: rise + fade in
  var UP = [
    '.section-header-info',
    '.easy-pack__item',
    '.single-product-wrap',
    '.collectionBanner-block',
    '.sm-card',
    '.ser-box',
    '.grid-wrapper',
    '.faqS_item',
    '.single-blog-area > li',
    '.service-wrapper',
    '.footer-list',
    '.about-eu__fact',
    '.about-eu__step',
    '.about-eu__card',
    '.about-eu__list li',
    '.about-eu__company'
  ];

  // Whole sections: gentle fade in
  var FADE = [
    '.our-brand-logo',
    '.why-choose-submed',
    '.ha-about-area',
    '.full-banner-area',
    '.about-section1',
    '.about-testimonial',
    '.contact-us-page',
    '.expert-hero',
    '.connect-contact-section',
    '.list-collection',
    '.product-metafield',
    '.related-product',
    '.faq-simple',
    '.faq-section1',
    '.contact-service-area',
    '.section-social-follow',
    '.blog-content-wrap',
    '.main-content-wrap'
  ];

  var UP_SEL = UP.join(',');
  var FADE_SEL = FADE.join(',');
  var EXCLUDE = '.owl-carousel, .swiper, .mobile-menu, .mini-cart, .modal, .megamenu-content, .surgical-hero, .slider-content';

  var pending = [];
  var flushTimer = null;
  var watched = new Set();

  function reveal(el, order) {
    if (!watched.has(el)) return;
    watched.delete(el);
    io.unobserve(el);
    el.style.transitionDelay = Math.min(order, 5) * 90 + 'ms';
    el.classList.add('is-visible');
    setTimeout(function () {
      el.classList.remove('reveal-up', 'reveal-fade', 'is-visible');
      el.style.transitionDelay = '';
    }, 1600);
  }

  var io = new IntersectionObserver(function (entries) {
    var visible = entries.filter(function (e) { return e.isIntersecting; });
    visible.sort(function (a, b) {
      return a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left;
    });
    visible.forEach(function (entry, i) { reveal(entry.target, i); });
  }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });

  // Safety net: anything scrolled past too quickly for the observer to see is shown immediately.
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking || !watched.size) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      watched.forEach(function (el) {
        if (el.getBoundingClientRect().bottom < 0) reveal(el, 0);
      });
    });
  }, { passive: true });

  function tag(el, cls, initial) {
    if (el.__revealed || el.closest(EXCLUDE) || (cls === 'reveal-up' && el.matches(FADE_SEL))) return;
    // Skip anything already on screen at first paint so the page never flashes.
    if (initial) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92) { el.__revealed = true; return; }
    }
    el.__revealed = true;
    el.classList.add(cls);
    watched.add(el);
    io.observe(el);
  }

  function scan(root, initial) {
    if (root.nodeType !== 1) return;
    if (root.matches(UP_SEL)) tag(root, 'reveal-up', initial);
    if (root.matches(FADE_SEL)) tag(root, 'reveal-fade', initial);
    root.querySelectorAll(FADE_SEL).forEach(function (el) { tag(el, 'reveal-fade', initial); });
    root.querySelectorAll(UP_SEL).forEach(function (el) { tag(el, 'reveal-up', initial); });
  }

  function init() {
    scan(document.body, true);

    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (n) { if (n.nodeType === 1) pending.push(n); });
        });
        if (pending.length && !flushTimer) {
          flushTimer = setTimeout(function () {
            var nodes = pending.splice(0);
            flushTimer = null;
            nodes.forEach(function (n) { scan(n, false); });
          }, 60);
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
